<template>
  <v-row class="mt-0">
    <v-col v-for="field in value" :key="field.name" :cols="field.cols" :md="field.md" v-if="!(mode == 'create' && field.hideOnCreate)">
      <v-text-field v-if="field.type=='text-field'" 
        :type="field.isDate == true ? 'date': ''"
        :value="field.value" 
        :label="field.label"
        :readonly="field?.readonly == true?? false"
        hide-details="auto" outlined dense :placeholder="field.placeholder??''" persistent-placeholder
        @change="changeHandler(field.name, $event)"
        ></v-text-field>
    
      <v-autocomplete v-if="field.type=='autocomplete'" 
      :value="field.value" :label="field.label" :items="field.items" hide-details="auto" 
      outlined dense placeholder="" persistent-placeholder
      @change="changeHandler(field.name, $event)"
      ></v-autocomplete>
      
      <v-textarea v-if="field.type=='textarea'"
       :value="field.value" :label="field.label" hide-details="auto" outlined dense placeholder="" persistent-placeholder
      @change="changeHandler(field.name, $event)"
       ></v-textarea>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "AutoForm",
  props: {
    value: {
      type: Array
    },
    mode: {
      type: String,
      default: 'view'
    },
    forcedUpdate: {
      type: Boolean,
      default: false
    }
  },
  computed: {
  },
  data() {
    return {
      changedFields: []
    }
  },
  methods: {
    changeHandler(name, value) {
      var changed = this.changedFields.find(f => f.name === name);
      if(changed) {
        changed.value = value;
      } else {
        this.changedFields.push({ name: name, value: value });
      }
      this.updateFields();

    },
    updateFields() {
      let result = Object.fromEntries(
        this.value.map(({ name, value }) => {
          var changed = this.changedFields.find(f =>f.name == name);
          return [name, changed ? changed.value : value];
        })
      );
      this.$emit('input', result);
    }
  },
  watch: {
    forcedUpdate(val) {
      this.updateFields()
    }
    // changedFields(value, oldVal) {
    //   let result = Object.fromEntries(
    //     this.fields.map(({ name, value }) => {
    //       var changed = this.changedFields.find(f =>f.name == name);
    //       return [name, changed ? changed.value : value];
    //     })
    //   );
    //   alert("changed auto form", JSON.stringify(value), JSON.stringify(oldVal))
    //   this.$emit('input', result); 
    // }
  },
  created() {
      this.updateFields();
  },
  updated() {
    this.changedFields = [];
  },
  destroyed() {
    this.changedFields = [];
  }
}
</script>